/*eslint-disable */
import React, { FC, useState, useContext } from "react";
import { createUseStyles, useTheme } from "react-jss";

import styles from "./styles";
import Info from "Assets/images/info.svg";
import Instagram from "Assets/images/instagram.svg";
import { motion } from "framer-motion";
import ShareMenuContainer from "Containers/ShareMenu";
import { MapContext } from "Context/MapContext";
import { sanitize } from "dompurify";

interface Props {
  media: any[];
  selectedIdx: number;
}

const InstagramViewer: FC<Props> = (props: Props) => {
  const { media, selectedIdx } = props;
  const useStyles = createUseStyles(styles);

  const [description, setDescription] = useState(false);

  const theme = useTheme();

  const classes = useStyles({ theme, ...props, state: { description } });

  const { instId, locId } = useContext(MapContext);

  const shareUrl = `${process.env.REACT_APP_API_BASE_URL}tour/photos/${instId}/${locId}?id=${media[selectedIdx]?.id}`;
  const embedId =
    media[selectedIdx].mediaType === "photo"
      ? media[selectedIdx].url
      : media[selectedIdx].videoid;

  const animations = {
    open: {
      x: "0%",
      transition: {
        ease: [0.28, 0.57, 0.2, 1],
        duration: 0.5,
      },
    },
    closed: {
      x: "100%",
      transition: {
        ease: "easeIn",
        duration: 0.25,
      },
    },
  };

  return (
    <div className={classes.viewer}>
      <div
        className={classes.imgText}
        id={"carousel-title-ig"}
        tabIndex={0}
        data-testid="title"
      >
        {media[selectedIdx].title}
      </div>
      <iframe
        className={classes.instagramMedia}
        src={`https://www.instagram.com/p/${embedId}/embed/?cr=1&wp=1080&rd=${encodeURIComponent(
          window.location.origin
        )}&rp=${encodeURIComponent(
          window.location.pathname.substring(0, 200)
        )}`}
        allowTransparency={true}
        frameBorder="0"
        scrolling="auto"
      ></iframe>

      <motion.div
        initial={{ x: "100%" }}
        variants={animations}
        animate={
          description || media[selectedIdx].network === "instagram"
            ? "open"
            : "closed"
        }
        className={classes.infoPanel}
      >
        <span className={classes.instagram}>
          <Instagram />
          <span className={classes.instagramTitle}>
            {media[selectedIdx].username}
          </span>
          <div
            tabIndex={0}
            id="carousel-description"
            className={classes.instagramDescription}
            onBlur={() => {
              document
                .getElementById(`carouselImages-${selectedIdx + 1}`)
                .focus();
            }}
            dangerouslySetInnerHTML={{
              __html: sanitize(
                media[selectedIdx].description || media[selectedIdx].title,
                { ADD_ATTR: ["target"] }
              ),
            }}
          ></div>
        </span>
      </motion.div>

      {media[selectedIdx].description && (
        <div
          aria-label="Open Description"
          role="button"
          tabIndex={0}
          className={classes.info}
          onClick={() => setDescription(!description)}
          data-testid="info"
        >
          <Info />
        </div>
      )}
      <div>
        <span
          style={{
            cursor: "pointer",
            position: "absolute",
            bottom: "0%",
            right: "2%",
          }}
        >
          <ShareMenuContainer url={shareUrl} svgColor="#FFFFFF" />
        </span>
      </div>
    </div>
  );
};

export default InstagramViewer;
